<!-- 共通テストカウントダウンバナー -->
<div class="bg-gradient-to-r from-[#F66286] to-[#F189E5] text-white relative exam-countdown-banner" *ngIf="isBannerVisible">
  <app-wrapper size="lg">
    <div class="exam-countdown-banner__inner">
      <div class="exam-countdown-banner__main">
        <span class="exam-countdown-banner__icon-wrap" aria-hidden="true">
          <mat-icon fontSet="material-icons-outlined">calendar_month</mat-icon>
        </span>
        <div class="exam-countdown-banner__texts">
          <span class="exam-countdown-banner__label">共通テストまで あと</span>
          <p class="exam-countdown-banner__date">{{ examDateLabel }}</p>
        </div>
        <div class="exam-countdown-banner__count">
          <span class="exam-countdown-banner__count-day">{{ daysRemaining }}</span>
          <span class="exam-countdown-banner__count-unit">日</span>
        </div>
      </div>
      <div class="exam-countdown-banner__actions">
        <button mat-flat-button class="exam-countdown-banner__cta exam-countdown-banner__cta--pc" (click)="viewKakomonClick.emit()">
          過去問を見る
        </button>
        <button mat-icon-button class="exam-countdown-banner__close" (click)="closeBanner()"><mat-icon>close</mat-icon></button>
      </div>
      <!-- SPのみ：フルワイドボタン -->
      <button mat-flat-button class="exam-countdown-banner__cta exam-countdown-banner__cta--sp" (click)="viewKakomonClick.emit()">
        過去問を見る
      </button>
    </div>
  </app-wrapper>
</div>
